import { render, staticRenderFns } from "./SlideMenu.vue?vue&type=template&id=d06ca888&scoped=true&"
import script from "./SlideMenu.vue?vue&type=script&lang=ts&"
export * from "./SlideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SlideMenu.vue?vue&type=style&index=0&id=d06ca888&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06ca888",
  null
  
)

export default component.exports